import { InstrumentDto } from '@/gen/publicApi'

import { cn } from '@/utils/cn'

import { StatusCircle } from '../statusCircle'
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props {
    className?: string
    state: InstrumentDto['state']
}

const circles = {
    Open: <StatusCircle variant="success" />,
    Halt: <StatusCircle variant="destructive" />,
}

export default function InstrumentStateCircle({ className, state }: Props) {
    const Cmp = circles[state]
    return (
        <Tooltip>
            <TooltipTrigger>
                <div className={cn(className)}>{Cmp}</div>
            </TooltipTrigger>
            <TooltipContent>{state}</TooltipContent>
        </Tooltip>
    )
}
